export const SEARCH_PENSION_EMPLOYERS = { type: "SEARCH_PENSION_EMPLOYERS" }
export const SEARCH_PENSION_EMPLOYERS_SUCCESS = {
    type: "SEARCH_PENSION_EMPLOYERS_SUCCESS",
}
export const SEARCH_PENSION_EMPLOYERS_FAIL = {
    type: "SEARCH_PENSION_EMPLOYERS_FAIL",
}


export const GET_PENSION_DETAIL = { type: "GET_PENSION_DETAIL" }
export const GET_PENSION_DETAIL_SUCCESS = {
    type: "GET_PENSION_DETAIL_SUCCESS",
}
export const GET_PENSION_DETAIL_FAIL = {
    type: "GET_PENSION_DETAIL_FAIL",
}
